import { Form } from "formik";
import styled, { css } from "styled-components";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left.svg";
import { ReactComponent as FormEdit } from "assets/icons/form-edit.svg";
import { Tabs, Tab } from "react-bootstrap";

export const ArrowLeftIcon = styled(ArrowLeft)`
  width: 24px;
  height: 24px;
  path,
  .a {
    fill: #000;
  }
  cursor: pointer;
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 400px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5e5e5e;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

export const BanksHeader = styled.header`
  h1 {
    font-size: 0.9rem;
    color: rgb(0, 0, 0);
    margin-bottom: 0px !important;
  }
  h2 {
    font-weight: normal;
    color: rgb(117, 117, 117);
    line-height: 1.5;
    font-size: 0.8rem;
  }
`;

export const Label = styled.span`
  color: #5e5e5e;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
  display: flex;
  align-items: center;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 30px;

  .textField {
    margin-bottom: 20px;
  }

  p {
    color: #5e5e5e;
    font-size: 0.9375rem;
    line-height: 26px;
    margin-bottom: 20px;
  }
`;

export const NumberDigit = styled.div`
  display: grid;
  grid-template-columns: ${props => props.isFull ? '1fr' : '1fr 20%'};
  column-gap: 20px;

  @media (max-width: 400px) {
    grid-template-columns: 1fr;
  }

  .digit span {
    font-size: 0.7rem;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  button {
    margin-bottom: 20px;
  }
`;

export const Text = styled.div`
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  cursor: pointer;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 0.9rem;
    color: #000;
    margin-bottom: 0px !important;
  }

  h2 {
    font-weight: normal;
    color: #757575;
    line-height: 1.5;
    font-size: 0.8rem;
  }
`;

export const Check = styled.div`
  width: 15px;
  height: 15px;
  margin-bottom: -9px;
  margin-right: -63px;
  background: #0ece00;
  color: white;
  z-index: 1;
  border-radius: 100%;
  display: flex;
  position: absolute;
  position: absolute;
  right: 0;
  top: 0;
  margin-top: -6px;
  margin-right: -5px;
`;

export const BankIcon = styled.img`
  width: 67px;
  height: 67px;
`;

export const TitleTab = styled.p`
  font-size: 11px;
  text-align: center;
  color: #2d2d2d;
  font-weight: bold;
  max-width: 65px;
  line-height: 11px;
  margin-top: 5px;
`;

export const ContainerTab = styled.div`
  max-width: 100%;
  width: 450px;
`;

export const Alert = styled.div`
  border: 2px solid #000fff;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 14px;
  color: #000fff;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  ul {
    padding-inline-start: 1rem;
    margin-bottom: 0;
  }
`;

export const BanksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(68px, 68px));
  column-gap: 17px;
  row-gap: 17px;
`;

export const BankContainer = styled.div`
  display: flex;
  flex-direction: column;
  place-items: center;
  position: relative;
  input {
    display: none;
  }
`;

export const BankLabel = styled.label`
  height: 67px;
  width: 67px;

  border-radius: 10px;
  transition: opacity 0.5s;
  opacity: 0.5;

  ${({ image }) =>
    image &&
    css`
      background-image: url(${image});
      background-repeat: no-repeat;
      background-size: 62px 62px;
    `}

  ${({ selected }) =>
    selected &&
    css`
      opacity: 1;
    `}
  input {
    display: none;
  }
`;

export const BankName = styled.span`
  color: #2d2d2d;
  font-weight: 500;
  font-size: 0.8125rem;
  text-align: center;
  text-transform: capitalize;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
`;

export const Error = styled.span`
  color: #dc3545;
  margin-bottom: 20px;
`;
